import { useState } from 'react';
import { Screen, Title } from '../components/ui';
import { CARDS } from '../content/cards';
import { getTopic } from '../content/topics';

export function Cards() {
  const [query, setQuery] = useState('');
  const needle = query.trim().toLowerCase();

  // Persistent search, because the point of a reference card is finding it
  // fast — including in the middle of a question.
  const shown = needle
    ? CARDS.filter((c) =>
        `${c.name} ${c.formula} ${c.note} ${getTopic(c.topicId).name}`
          .toLowerCase()
          .includes(needle),
      )
    : CARDS;

  return (
    <Screen>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Title>Cards</Title>
        <div
          style={{ font: '400 13px/1.4 var(--font-body)', color: 'var(--text-4)', textWrap: 'pretty' }}
        >
          Look these up any time, including mid-question. Nobody does this from memory.
        </div>
      </div>

      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search formulas"
        aria-label="Search formulas"
        style={{
          width: '100%',
          minHeight: 48,
          padding: '0 16px',
          borderRadius: 12,
          background: 'var(--surface-2)',
          border: '1px solid var(--line-strong)',
          color: 'var(--text)',
          font: '400 15px/1 var(--font-body)',
          outline: 'none',
        }}
      />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {shown.map((c) => (
          <div
            key={c.name}
            style={{
              padding: '14px 16px',
              borderRadius: 14,
              background: 'var(--surface)',
              border: '1px solid var(--line)',
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
          >
            <div
              style={{
                font: '600 11px/1 var(--font-body)',
                letterSpacing: '.13em',
                textTransform: 'uppercase',
                color: 'var(--text-4)',
              }}
            >
              {c.name}
            </div>
            <div
              className="num"
              style={{ font: '700 17px/1.35 var(--font-display)', color: 'var(--lime-bright)' }}
            >
              {c.formula}
            </div>
            <div
              style={{
                font: '400 13px/1.45 var(--font-body)',
                color: 'var(--text-3)',
                textWrap: 'pretty',
              }}
            >
              {c.note}
            </div>
          </div>
        ))}

        {shown.length === 0 && (
          <div style={{ font: '400 14px/1.5 var(--font-body)', color: 'var(--text-4)' }}>
            Nothing matches “{query}”.
          </div>
        )}
      </div>
    </Screen>
  );
}
